import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postFlush } from '../../../api/notifications';
import { queryKeys } from '../../../api/queryKeys';
import { useToast } from '../../../hooks/useToast';

export function useFlushQueue() {
  const qc = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: postFlush,
    onSuccess: async (data) => {
      toast.success(`Queue processed — ${data.sent} sent, ${data.failed} failed`);
      await qc.invalidateQueries({ queryKey: queryKeys.notifications.all });
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { status?: number; data?: { error?: { retry_after_seconds?: number } } } };
      const status = axiosErr?.response?.status;
      if (status === 429) {
        const retryAfter = axiosErr.response?.data?.error?.retry_after_seconds ?? 30;
        toast.warning(`Try again in ${retryAfter}s — queue was flushed recently`);
      } else {
        toast.error('Could not flush queue');
      }
    },
  });
}
